import cloudbase from '@cloudbase/js-sdk'

const app = cloudbase.init({
  env: import.meta.env.VITE_TCB_ENV || 'cloudbase-3gianxb15fbd1fc1',
  region: import.meta.env.VITE_TCB_REGION || 'ap-shanghai'
})

const auth = app.auth({ persistence: 'local' })
const db = app.database()
const _ = db.command

export async function ensureLogin() {
  const state = await auth.getLoginState()
  if (state) return
  await auth.signInAnonymously()
}

export { db, _, app, auth }
